export const THEME_COLOR_PRIMARY = '#fff'
export const THEME_COLOR_ACCENT = '#5865f2'
export const THEME_BACKGROUND = '#36393f'



// WEBPACK FOOTER //
// ./src/constants/theme.ts